const deleteButtonSelector: string = "button.entry-remove"
const shareButtonSelector: string = "button.entry-share"
const tagButtonSelector: string = "button.entry-tag-apply"
const notesRatingButtonSelector: string = "button.entry-notes-rating"

export interface EntryOptions {
    deleteButton: () => NodeListOf<HTMLButtonElement>
    shareButton: () => NodeListOf<HTMLButtonElement>
    tagButton: () => NodeListOf<HTMLButtonElement>
    notesRatingButton: () => NodeListOf<HTMLButtonElement>
}

export const getOptionButtonsForCard = (card: HTMLArticleElement): EntryOptions => {
    let deleteButtonElements: NodeListOf<HTMLButtonElement>
    let shareButtonElements: NodeListOf<HTMLButtonElement>
    let tagButtonElements: NodeListOf<HTMLButtonElement>
    let notesRatingButtonElements: NodeListOf<HTMLButtonElement>

    return {
        deleteButton(): NodeListOf<HTMLButtonElement> {
            deleteButtonElements ??= card.querySelectorAll<HTMLButtonElement>(deleteButtonSelector)
            return deleteButtonElements
        },
        shareButton(): NodeListOf<HTMLButtonElement> {
            shareButtonElements ??= card.querySelectorAll<HTMLButtonElement>(shareButtonSelector)
            return shareButtonElements
        },
        tagButton(): NodeListOf<HTMLButtonElement> {
            tagButtonElements ??= card.querySelectorAll<HTMLButtonElement>(tagButtonSelector)
            return tagButtonElements
        },
        notesRatingButton(): NodeListOf<HTMLButtonElement> {
            notesRatingButtonElements ??= card.querySelectorAll<HTMLButtonElement>(notesRatingButtonSelector)
            return notesRatingButtonElements
        },
    }
}
